document.addEventListener('DOMContentLoaded', () => {
  const button = document.querySelector('.ff-menu-button');
  const navigation = document.querySelector('#ff-navigation');
  if (button && navigation) {
    button.addEventListener('click', () => {
      const open = navigation.classList.toggle('ff-open');
      button.setAttribute('aria-expanded', String(open));
    });
    navigation.addEventListener('click', (event) => {
      if (event.target.matches('a')) {
        navigation.classList.remove('ff-open');
        button.setAttribute('aria-expanded', 'false');
      }
    });
  }

  if ('IntersectionObserver' in window) {
    const observer = new IntersectionObserver((entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add('ff-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.ff-reveal').forEach((element) => observer.observe(element));
  } else {
    document.querySelectorAll('.ff-reveal').forEach((element) => element.classList.add('ff-visible'));
  }

  document.querySelectorAll('[data-ff-privacy-settings]').forEach((link) => {
    link.addEventListener('click', (event) => {
      if (window.Shopify?.customerPrivacy?.showPreferences) {
        event.preventDefault();
        window.Shopify.customerPrivacy.showPreferences();
      }
    });
  });

  document.querySelectorAll('[data-ff-variant-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const option = select.options[select.selectedIndex];
      const form = select.closest('form');
      const price = document.querySelector('[data-ff-product-price]');
      const button = form?.querySelector('[data-ff-add-to-cart]');
      const available = option.dataset.available === 'true';
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (button) {
        button.disabled = !available;
        button.textContent = available ? 'In den Warenkorb' : 'Ausverkauft';
      }
    });
  });
});
